export const opsViewRoles = ['developer', 'super_admin', 'admin', 'ops_admin', 'finance_admin', 'finance_approver', 'security_auditor', 'system_operator'];
export const opsManageRoles = ['developer', 'super_admin', 'admin', 'ops_admin'];
export const financeViewRoles = ['developer', 'super_admin', 'admin', 'finance_admin', 'finance_approver', 'security_auditor'];
export function validMarkup(value) {
    return typeof value === 'string' && /^(0|[1-9][0-9]{0,18})$/.test(value) && BigInt(value) <= 9223372036854775807n;
}
export function rupiah(value) {
    if (typeof value === 'number' && !Number.isSafeInteger(value)) return 'Tidak tersedia';
    const text = String(value ?? '');
    return /^-?[0-9]+$/.test(text) ? 'Rp ' + BigInt(text).toLocaleString('id-ID') : 'Tidak tersedia';
}
export const syncConfirmation = 'Sinkronisasi akan mengambil katalog dan harga terbaru dari Digiflazz serta memperbarui katalog Warung PAY. Tidak ada transaksi pelanggan yang dijalankan.';
